export default class AbstractPolicy {
    static viewAny(user, model = null) {
        return true;
    }

    static view(user, model = null) {
        return true;
    }

    static create(user, model = null) {
        return true;
    }

    static update(user, model = null) {
        return true;
    }

    static delete(user, model = null) {
        return true;
    }

    static restore(user, model = null) {
        return true;
    }

    static forceDelete(user, model = null) {
        return true;
    }

    static _userHasRole(user, role) {
        return !!user.roles.find(otherRole => {
            return role.name === otherRole.name;
        });
    }

    static _userHasPermission(user, permission) {
        if (this._checkPermissions(user.permissions, permission)) {
            return true;
        }

        this._checkRolesForPermission(user.roles, permission);
    }

    static _checkRolesForPermission(roles, permission) {
        return !!roles.find(role => {
            return this._checkPermissions(role.permissions, permission);
        });
    }

    static _checkPermissions(permissions, permission) {
        return !!permissions.find(otherPermission => otherPermission.name === permission);
    }
}
